// Etiquetas legibles para cada rol del sistema
export const ROLE_LABELS = {
  ADMIN: 'Admin',
  SUPERVISOR: 'Supervisor',
  TECHNICIAN: 'Técnico',
};

/**
 * @description Formatea el autor de una actividad del historial junto al rol que tenía
 * cuando la registró (technician_role). Si el rol no viene, muestra solo el nombre.
 * @param {string} name - Nombre del autor.
 * @param {string} [role] - Rol con el que registró la actividad.
 * @returns {string} Ej: "jperez (Técnico)".
 */
export const formatNameWithRole = (name, role) => {
  if (!role) return name;
  return `${name} (${ROLE_LABELS[role] || role})`;
};
